const preventDefault = (e: any) => {
  e.preventDefault();
  e.stopPropagation();
};
export default preventDefault;
